import { Stack, Tooltip, Typography } from "@mui/material";
import { RatingScoreBox } from "../../common/styles/Box.styles";
import { TaskStatusIcon } from "../../common/styles/Form.styles";
import { SmallText } from "../../common/styles/Text.styles";
import {
  borderOrange,
  borderStyle,
  defaultTransition,
  perelynDarkBlue,
  perelynLightBlue,
  perelynPrimary,
  smallGap,
  tinyGap,
} from "../../styles/consts";

export default function Candidate({ match, isDisplayed, onClick, disabled, showDetailedScores = false, isInactive = false }) {
  const isSent = match.status === "sent";
  // Inactive pills fade unless they're the currently displayed selection,
  // where fading would clash with the orange highlight.
  const fadeForInactive = isInactive && !isDisplayed;
  return (
    <Stack
      data-inactive={isInactive ? "true" : undefined}
      onClick={disabled ? undefined : onClick}
      sx={{
        flexDirection: "row",
        border: isDisplayed ? borderOrange : borderStyle,
        padding: tinyGap,
        width: "fit-content",
        alignItems: "center",
        gap: smallGap,
        transition: defaultTransition,
        opacity: disabled ? 0.6 : fadeForInactive ? 0.65 : 1,
        "&:hover": disabled ? {} : {
          border: borderOrange,
          cursor: "crosshair",
          "& > *": {
            color: perelynPrimary,
          },
        },
      }}
    >
      <Stack sx={{ flexDirection: "row", alignItems: "center", gap: smallGap }}>
        <Typography
          sx={{
            transition: defaultTransition,
            color: isDisplayed && perelynPrimary,
            whiteSpace: "nowrap",
          }}
        >
          {match.candidate.name}
        </Typography>
        {isSent && (
          <TaskStatusIcon
            sx={{
              backgroundColor: perelynLightBlue,
              opacity: 0.9,
            }}
          >
            <SmallText
              id="status"
              sx={{
                whiteSpace: "nowrap",
                color: perelynDarkBlue,
                width: "3rem",
                textAlign: "center",
              }}
            >
              Sent
            </SmallText>
          </TaskStatusIcon>
        )}
      </Stack>

      <Stack sx={{ flexDirection: "row", gap: tinyGap, alignItems: "center" }}>
        <RatingScoreBox>{match.score}</RatingScoreBox>
        {showDetailedScores && match.score_cv_adapted != null && (
          <Tooltip title="Score after CV adaptation" arrow>
            <RatingScoreBox>{match.score_cv_adapted}</RatingScoreBox>
          </Tooltip>
        )}
        {showDetailedScores && match.score_consultant_edited != null && (
          <Tooltip title="Score after consultant review" arrow>
            <RatingScoreBox>{match.score_consultant_edited}</RatingScoreBox>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
}
